import service from '@/api';

/**
 * 코어독해 시작
 * @param {*} params
 * @param {*} callback
 * @returns
 */
export const postCornerStart = async (params, callback) => {
    // const { data } = await service.get(`/api/lesson/start`);
    const { data } = await service({
        url: '/api/lesson/start',
        method: 'post',
        data: params,
    });
    if (data && (data?.statusCode === 200 || data?.statusCode === '200')) return callback(data.data);
    return null;
};

/**
 * 코어독해 시작
 * @param {*} params
 * @param {*} callback
 * @returns
 */
export const postPassageTime = async (params, callback) => {
    // const { data } = await service.get(`/api/lesson/start`);
    const { data } = await service({
        url: '/api/lesson-time/save/passage-time',
        method: 'post',
        data: params,
    });
    if (data && (data?.statusCode === 200 || data?.statusCode === '200')) return callback(data.data);
    return null;
};

/**
 * 코어독해 시작
 * @param {*} params
 * @param {*} callback
 * @returns
 */
export const postVideoTime = async (params, callback) => {
    // const { data } = await service.get(`/api/lesson/start`);
    const { data } = await service({
        url: '/api/lesson-time/save/video-time',
        method: 'post',
        data: params,
    });
    if (data && (data?.statusCode === 200 || data?.statusCode === '200')) return callback(data.data);
    return null;
};

/**
 * 코너 종료
 * @param {*} params
 * @param {*} callback
 * @returns
 */
export const postCornerEnd = async (params, callback) => {
    // const { data } = await service.get(`/api/lesson/start`);
    const { data } = await service({
        url: '/api/corner/end/' + params.type,
        method: 'post',
        data: params.data,
    });
    if (data && (data?.statusCode === 200 || data?.statusCode === '200')) return callback(data.data);
    return null;
};

/**
 * 레슨 종료
 * @param {*} params
 * @param {*} callback
 * @returns
 */
export const postLessonEnd = async (params, callback) => {
    // const { data } = await service.get(`/api/lesson/start`);
    const { data } = await service({
        url: '/api/lesson/end',
        method: 'post',
        data: params,
    });
    if (data && (data?.statusCode === 200 || data?.statusCode === '200')) return callback(data.data);
    return null;
};

/**
 * 답변저장
 * @param {*} params
 * @param {*} callback
 * @returns
 */
export const postAnswer = async (params, callback) => {
    // const { data } = await service.get(`/api/lesson/start`);
    const { data } = await service({
        url: '/api/lesson/answer/' + params.type,
        method: 'post',
        data: params.data,
    });
    // if (data && (data?.statusCode === 200 || data?.statusCode === '200'))
    return callback(data?.data);
    // return null;
};

/**
 * 기존 답변 내역 불러오기
 * @param {examName:시험지명,learningType:학습타입(NORMAL/SUGGESTION/SAT)} params
 * @param {*} callback
 * @returns
 */
export const getAnswer = async (params, callback) => {
    try {
        const { data } = await service({
            url: '/api/lesson/answer_list/' + params.type,
            method: 'get',
            params: params.data,
        });
        if (data?.statusCode == 200) return callback(data.data);
    } catch (error) {
        console.log(`getAnswer error: ${error}`);
    }
};

/**
 * 다음 학습 정보
 * @param {*} params
 * @param {*} callback
 * @returns
 */
export const getLessonNext = async (params, callback) => {
    // const { data } = await service.get(`/api/lesson/start`);
    const { data } = await service({
        url: '/api/lesson/next',
        method: 'get',
        params,
    });
    if (data && (data?.statusCode === 200 || data?.statusCode === '200')) return callback(data.data);
    return null;
};

/**
 * 보고서 데이터
 * @param {level:1,lesson:1,areaCode:02,learningTypeCode:1} params
 * @param {*} callback
 * @returns
 */
export const getReportArea = async (params, callback) => {
    // const { data } = await service.get(`/api/lesson/start`);
    const { data } = await service({
        url: '/api/report/area',
        method: 'get',
        params,
    });
    if (data && (data?.statusCode === 200 || data?.statusCode === '200')) return callback(data.data);
    return null;
};
/**
 * 보고서 데이터
 * @param {level:1,lesson:1,areaCode:02,learningTypeCode:1} params
 * @param {*} callback
 * @returns
 */
export const getReportAreaSuggestion = async (params, callback) => {
    // const { data } = await service.get(`/api/lesson/start`);
    const { data } = await service({
        url: '/api/report/area/suggestion',
        method: 'get',
        params,
    });
    if (data && (data?.statusCode === 200 || data?.statusCode === '200')) return callback(data.data);
    return null;
};
/**
 * 수능 보고서 데이터
 * @param {level:1,lesson:1,areaCode:02,learningTypeCode:1} params
 * @param {*} callback
 * @returns
 */
export const getReportSat = async (params, callback) => {
    // const { data } = await service.get(`/api/lesson/start`);
    const { data } = await service({
        url: '/api/report/sat',
        method: 'get',
        params,
    });
    if (data && (data?.statusCode === 200 || data?.statusCode === '200')) return callback(data.data);
    return null;
};
/**
 * 진단평가 보고서 데이터
 * @param {diagnosticSeq:1} params
 * @param {*} callback
 * @returns
 */
export const getReportDiagnostic = async (params, callback) => {
    // const { data } = await service.get(`/api/lesson/start`);
    const { data } = await service({
        url: '/api/report/diagnostic',
        method: 'get',
        params,
    });
    if (data && (data?.statusCode === 200 || data?.statusCode === '200')) return callback(data.data);
    return null;
};
/**
 * 다시풀기 데이터
 * @param {answerHistorySeq:3997} params
 * @param {*} callback
 * @returns
 */
export const getReportReview = async (params, callback) => {
    // const { data } = await service.get(`/api/lesson/start`);
    const { data } = await service({
        url: '/api/report/area/review',
        method: 'get',
        params,
    });
    if (data && (data?.statusCode === 200 || data?.statusCode === '200')) return callback(data.data);
    return null;
};
/**
 * 진단평가 다시풀기 데이터
 * @param {answerHistorySeq:3997} params
 * @param {*} callback
 * @returns
 */
export const getReportDiagnosticReview = async (params, callback) => {
    // const { data } = await service.get(`/api/lesson/start`);
    const { data } = await service({
        url: '/api/report/diagnostic/review',
        method: 'get',
        params,
    });
    if (data && (data?.statusCode === 200 || data?.statusCode === '200')) return callback(data.data);
    return null;
};

/**
 * 수능평가 시작
 * @param {*} params
 * @param {*} callback
 * @returns
 */
export const postSatStart = async (params, callback) => {
    // const { data } = await service.get(`/api/lesson/start`);
    const { data } = await service({
        url: '/api/sat/start',
        method: 'post',
        data: params,
    });
    if (data && (data?.statusCode === 200 || data?.statusCode === '200')) return callback(data.data);
    return null;
};

/**
 * 수능 평가 종료
 * @param {*} params
 * @param {*} callback
 * @returns
 */
export const postSatEnd = async (params, callback) => {
    // const { data } = await service.get(`/api/lesson/start`);
    const { data } = await service({
        url: '/api/sat/end',
        method: 'post',
        data: params,
    });
    if (data && (data?.statusCode === 200 || data?.statusCode === '200')) return callback(data.data);
    return null;
};

/**
 * 영역결과보고서 리포트 리스트
 * @param {level:1,lesson:1} params
 * @param {*} callback
 * @returns
 */
export const getReportList = async (params, callback) => {
    try {
        const { data } = await service({
            url: '/api/report-list/area',
            method: 'get',
            params,
        });
        if (data?.statusCode == 200) return callback(data.data);
    } catch (error) {
        console.log(`getReportList error: ${error}`);
    }
};

/**
 * 수능모의평가 리포트 리스트
 * @param {level:1} params
 * @param {*} callback
 * @returns
 */
export const getReportListSat = async (params, callback) => {
    // const { data } = await service.get(`/api/lesson/start`);
    const { data } = await service({
        url: '/api/report-list/sat',
        method: 'get',
        params,
    });
    if (data && (data?.statusCode === 200 || data?.statusCode === '200')) return callback(data.data);
    return null;
};

/**
 * 수능모의평가 리포트 리스트
 * @param {} params
 * @param {*} callback
 * @returns
 */
export const getReportListDiagnostic = async (params, callback) => {
    // const { data } = await service.get(`/api/lesson/start`);
    const { data } = await service({
        url: '/api/report-list/diagnostic',
        method: 'get',
        params,
    });
    if (data && (data?.statusCode === 200 || data?.statusCode === '200')) return callback(data.data);
    return null;
};

/**
 * 2023-12-11 pby KRT-2148 -- 개발 - 구현_월간분석리포트
 * @param {} params
 * @param {*} callback
 * @returns
 */
export const getReportMonthlyAnalysis = async (params, callback) => {
    // const { data } = await service.get(`/api/lesson/start`);
    const { data } = await service({
        url: '/api/report-list/monthlyAnalysis',
        method: 'get',
        params,
    });
    if (data && (data?.statusCode === 200 || data?.statusCode === '200')) return callback(data.data);
    return null;
};

/**
 * 2023-12-19 pby KRT-2148 -- 개발 - 구현_월간분석리포트
 * @param {} params
 * @param {*} callback
 * @returns
 */
export const getReportMonthlyAnalysisData = async (params, callback) => {
    // const { data } = await service.get(`/api/lesson/start`);
    const { data } = await service({
        url: '/api/report/monthlyAnalysis',
        method: 'post',
        data: {
            studentSeq: params.studentSeq,
            groupNo: params.groupNo,
        },
    });
    if (data && (data?.statusCode === 200 || data?.statusCode === '200')) return callback(data.data);
    return null;
};

/**
 * 진도수정 체크
 * @param {} params
 * @param {*} callback
 * @returns
 */
export const checkProgress = async (callback) => {
    try {
        const { data } = await service.get('/api/chk-modify-progress/check');
        if (data?.statusCode == 200) return callback(data.data);
    } catch (error) {
        console.log(`checkProgress error: ${error}`);
    }
};
/**
 * FAQ 리스트
 * @param {} params
 * @param {*} callback
 * @returns
 */
export const getFaq = async (params, callback) => {
    // const { data } = await service.get(`/api/lesson/start`);
    const { data } = await service({
        url: '/api/my-page/faq/list',
        method: 'get',
        params,
    });
    if (data && (data?.statusCode === 200 || data?.statusCode === '200')) return callback(data.data);
    return null;
};

/**
 * 독해력 리포트 리스트
 * @param {level:1} params
 * @param {*} callback
 * @returns
 */
export const getReportListKread = async (params, callback) => {
    // const { data } = await service.get(`/api/lesson/start`);
    const { data } = await service({
        url: '/api/report-list/kread',
        method: 'get',
        params,
    });
    if (data && (data?.statusCode === 200 || data?.statusCode === '200')) return callback(data.data);
    return null;
};

/**
 * 독해력 리포트
 * @param {level:1} params
 * @param {*} callback
 * @returns
 */
export const getReportKread = async (params, callback) => {
    // const { data } = await service.get(`/api/lesson/start`);
    const { data } = await service({
        url: '/api/report/kread',
        method: 'get',
        params,
    });
    if (data && (data?.statusCode === 200 || data?.statusCode === '200')) return callback(data.data);
    return null;
};

/**
 * 2024-02-20 pby NewDreams 레슨 시작 콜 API
 * @param {} params
 * @param {*} callback
 * @returns
 */
export const callNewDreamsStartTime = async (params, callback) => {
    // const { data } = await service.get(`/api/lesson/start`);
    const { data } = await service({
        url: '/api/user/callStartTime',
        method: 'post',
        data: {
            mbrNo: params.mbrNo,
            corsCd: params.corsCd,
            setCd: params.setCd,
        },
    });
    if (data && (data?.statusCode === 200 || data?.statusCode === '200')) return callback(data.data);
    return null;
};
